import React from "react";

import LottieAnimationWrapper from "./Lottie/LottieAnimationWrapper";

import animation from "assets/lottie/tms.json";

const CustomLoader = () => {
  return <LottieAnimationWrapper lottieFile={animation} height={300} />;
};

export default CustomLoader;
